import { render, staticRenderFns } from "./EmptyBuckets.vue?vue&type=template&id=fc1d4164&scoped=true&"
import script from "./EmptyBuckets.vue?vue&type=script&lang=js&"
export * from "./EmptyBuckets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1d4164",
  null
  
)

export default component.exports